module.exports = __webpack_public_path__ + "static/media/urgentCareOffices.9a303b1c.jpg";